import {
  RadioOption,
  RadioOptionExtended,
} from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export interface getExpenseSettingsSubheaderProps {
  expenseCodes: RadioOptionExtended;
  expenseComments: RadioOptionExtended;
  expenseReason: RadioOption;
  expenseCodesForLabel: string;
}

type ExpenseSettingEntry = {
  option: RadioOption | RadioOptionExtended;
  label: string;
};

export interface HandleRadioOptionParams {
  option: RadioOptionExtended | RadioOption;
  label: string;
  required: string[];
  optional: string[];
  notRequired: string[];
}

export function handleRadioOption({
  option,
  label,
  required,
  optional,
  notRequired,
}: HandleRadioOptionParams): void {
  switch (option) {
    case RadioOptionExtended.YES:
    case RadioOption.YES:
      required.push(label);
      break;
    case RadioOptionExtended.NO:
    case RadioOption.NO:
      notRequired.push(label);
      break;
    case RadioOptionExtended.OPTIONAL:
      optional.push(label);
      break;
    default:
      break;
  }
}

export function getExpenseSettingsSubheader({
  expenseCodes,
  expenseComments,
  expenseReason,
  expenseCodesForLabel,
}: getExpenseSettingsSubheaderProps): string {
  const required: string[] = [];
  const optional: string[] = [];
  const notRequired: string[] = [];

  const settings: ExpenseSettingEntry[] = [
    { option: expenseCodes, label: expenseCodesForLabel },
    { option: expenseComments, label: 'Expense comments' },
    { option: expenseReason, label: 'Expense reasons' },
  ];

  settings.forEach(({ option, label }) =>
    handleRadioOption({ option, label, required, optional, notRequired })
  );

  const parts: string[] = [];
  if (required.length > 0) {
    parts.push(`Required: ${required.join(', ')}`);
  }
  if (notRequired.length > 0) {
    parts.push(`Not required: ${notRequired.join(', ')}`);
  }
  if (optional.length > 0) {
    parts.push(`Optional: ${optional.join(', ')}`);
  }

  return parts.join('. ');
}
